import React, { useState, useContext, useEffect } from "react";
import { Table, Divider, Popconfirm, Typography } from "antd";
import { withRouter } from "react-router-dom";
import { ContextAPI } from "../../../../ContextAPI";
import moment from "moment";

const { Text } = Typography;

const CityTable = ({
  pagination,
  dataSource,
  openModal,
  spinner,
  delete: deleteData,
}) => {
  const { loginCredintials } = useContext(ContextAPI);
  const [modifyAccess, setModifyAccess] = useState(true);
  const [deleteAccess, setDeleteAccess] = useState(true);

  useEffect(() => {
    if (loginCredintials && loginCredintials.roleAccess) {
      loginCredintials.roleAccess.forEach((each) => {
        if (each.subModule === "city") {
          setModifyAccess(!!(each.access && each.access.update));
          setDeleteAccess(!!(each.access && each.access.delete));
        }
      });
    }
  }, [loginCredintials]);

  const columns = [
    {
      title: "City Name",
      dataIndex: "name",
      key: "name",
      render: (text) => <span>{text}</span>,
    },
    {
      title: "City Code",
      dataIndex: "code",
      key: "code",
      render: (text) => <span>{text || "-"}</span>,
    },
    {
      title: "State",
      dataIndex: "State",
      key: "state",
      render: (state) => <span>{state ? state.name : "-"}</span>,
    },
    {
      title: "Created On",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (record) => <span>{record ? moment(new Date(record)).format("DD/MM/YYYY") : "-"}</span>,
    },
    {
      title: "Action",
      key: "action",
      render: (data) => (
        <div>
          {modifyAccess ? (
            <span
              onClick={(event) => {
                event.stopPropagation();
                openModal(data.id, true);
              }}
              className="linkylink"
            >
              Modify
            </span>
          ) : null}

          {deleteAccess ? (
            <Popconfirm
              title="Are you sure you want to delete this City?"
              okText="Yes"
              cancelText="No"
              onCancel={(event) => {
                event.stopPropagation();
              }}
              onConfirm={(event) => {
                event.stopPropagation();
                deleteData(data.id);
              }}
            >
              <span
                className="linkylink"
                onClick={(event) => event.stopPropagation()}
              >
                {modifyAccess ? <Divider type="vertical" /> : null}
                Delete
              </span>
            </Popconfirm>
          ) : null}

          {!modifyAccess && !deleteAccess ? (
            <Text strong disabled>
              No Actions Given
            </Text>
          ) : null}
        </div>
      ),
    },
  ];

  return (
    <Table
      rowKey={(record) => record.id}
      pagination={pagination}
      columns={columns}
      dataSource={dataSource}
      style={{ cursor: "pointer" }}
      onRow={(record) => ({
        onClick: () => {
          openModal(record.id, false);
        },
      })}
      loading={spinner}
    />
  );
};

export default withRouter(CityTable);
